import el from "@cypherpotato/el";
import { Icon } from "./icon";

export function Warning(...children) {
    return el("div.alert.warning",
        Icon("error-warning-line"),
        el("div", ...children)
    );
}

export function Information(...children) {
    return el("div.alert.information",
        Icon("information-line"),
        el("div", ...children)
    );
}